import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { PublicRoutingModule } from './public-routing.module';
import { PublicCommonService } from './public.common.service';
import { MainComponent } from './components/main/main.component';
import { RouletteSettingsComponent } from './components/web-roulette/roulette-settings/roulette-settings.component';
import { RouletteGeneralDetailsComponent } from './components/web-roulette/roulette-general-details/roulette-general-details.component';
import { RouletteLogoSettingsComponent } from './components/web-roulette/roulette-logo-settings/roulette-logo-settings.component';
import { RouletteDesignSettingsComponent } from './components/web-roulette/roulette-design-settings/roulette-design-settings.component';
import { RouletteCouponsSettingsComponent } from './components/web-roulette/roulette-coupons-settings/roulette-coupons-settings.component';
import { RouletteComponent } from './components/web-roulette/roulette/roulette.component';
 import { CustomerTellingComponent } from './components/landing-page/customer-telling/customer-telling.component';
import { CustomersTellingComponent } from './components/landing-page/customers-telling/customers-telling.component';
import { LandingPageComponent } from './components/landing-page/landing-page/landing-page.component';
import { LoginModule } from 'app/login/login.module';
import { ReasonsForUsingOurProductComponent } from './components/landing-page/reasons-for-using-our-product/reasons-for-using-our-product.component';
import { TopbarComponent } from './components/landing-page/topbar/topbar.component';
import { RouletteSubscribtionComponent } from './components/subscribtion/roulette-subscribtion/roulette-subscribtion.component';
import { PaymentCompleteComponent } from './components/subscribtion/payment-complete/payment-complete.component';
import { NgxStripeModule } from 'ngx-stripe';
import { LiveRouletteComponent } from './components/web-roulette/roulette-preview/live-roulette/live-roulette.component';
import { QuestionsComponent } from './components/landing-page/questions/questions.component';
import { RouletteCouponsSettingsItemComponent } from './components/web-roulette/roulette-coupons-settings/roulette-coupons-settings-item/roulette-coupons-settings-item.component';
import { LastCreatedRoulettesComponent } from './components/landing-page/last-created-roulettes/last-created-roulettes.component';
import { environment } from 'environments/environment';
import { RoulettePreviewComponent } from './components/web-roulette/roulette-preview/roulette-preview/roulette-preview.component';
import { LandingMobileMenuComponent } from './components/landing-page/landing-mobile-menu/landing-mobile-menu.component';
import { TermsOfUseComponent } from './components/terms-of-use/terms-of-use.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { DisplayCardsComponent } from './components/landing-page/display-cards/display-cards.component';
import { AboutUsComponent } from './components/landing-page/about-us/about-us.component';
import { AnalyticsService } from './services/analytics.service';
import { FieldDialogComponent } from './components/web-roulette/field-dialog/field-dialog.component';
import { RefundCancellationPolicyComponent } from './components/refund-cancellation-policy/refund-cancellation-policy.component';




@NgModule({
  imports: [
    CommonModule, FormsModule,
    PublicRoutingModule,
    PdfViewerModule,
    SharedModule.forRootOrChild(),
    // test key
    // NgxStripeModule.forRoot('pk_test_51IoNshFM2FNR3cWY9gufatoeaaFGDBSVgH7WuxN7xh3vpwSZLFR3gfOAjF6kJCoo0d1wQr7v8HcrCI4RXlHf3jsq00VuiBSuax'),
    //---production key 
    //NgxStripeModule.forRoot('pk_live_51IoNshFM2FNR3cWY14coFsASW1SyrVv6gSJHN3RlX6pDKksWT0pWX9uA1Eb4wfdRpp54sqrcHKEw2E5mkm07rql90091htzcRU'),
    //change per config
    NgxStripeModule.forRoot(environment.NgxStripeModule),

  ],
  declarations: [MainComponent, RoulettePreviewComponent, RouletteSettingsComponent, RouletteGeneralDetailsComponent,
    RouletteLogoSettingsComponent, RouletteDesignSettingsComponent, RouletteCouponsSettingsComponent, RouletteComponent, RouletteSubscribtionComponent, PaymentCompleteComponent
    , CustomerTellingComponent, CustomersTellingComponent, LandingPageComponent, TopbarComponent, ReasonsForUsingOurProductComponent, QuestionsComponent, LiveRouletteComponent,TermsOfUseComponent,PrivacyPolicyComponent
    , RouletteCouponsSettingsItemComponent,FieldDialogComponent,RefundCancellationPolicyComponent,
    LastCreatedRoulettesComponent, LandingMobileMenuComponent, DisplayCardsComponent, AboutUsComponent],
  providers: [PublicCommonService],
})
export class PublicModule { }
